<section fxLayout="column" fxFlex>
  <vdw-header [title]="'GENERAL.ACTIONS.SELECT_OBJECT' | bmsTranslate: {object: 'MACHINE.MACHINE' | bmsTranslate: {count: 1} | lowercase}" svgIcon="select-blue"></vdw-header>
  <article fxFlex class="dialog-content">
    <ag-grid-angular #machinesGrid class="ag-theme-vdw" appDataCy="grid" [gridOptions]="gridOptionsForListOfMachines" [rowData]="listOfMachines"></ag-grid-angular>
  </article>
  <vdw-footer [locked]="!canSelectMachine()" [centered]="true" (chooseEvent)="selectMachine()"></vdw-footer>
</section>
